define('base/itemview',['require','exports','module','base/view'],function(require, exports, module) {
  "use strict";

  var View = require("base/view");

  var ItemView = View.extend({
    constructor: function() {
      ItemView.__super__.constructor.apply(this, arguments);
    },
    onRender: function() {
      this.$el.i18n();
    }
  });

  module.exports = ItemView;

});

